/**
 * 下载文件流
 * @param {*} response 
 * @param {*} filename 指定的文件名 
 * @param {*} afterTheSuccessFn 下载成功后执行的方法
 */
export const downloadFileStream = async (response, afterTheSuccessFn = () => { }, filename) => {
    const blob = await response.blob();
    // 获取文件名
    const disposition = response.headers?.get?.('content-disposition');
    let name = `download_${Date.now()}`;
    if (disposition && disposition.includes('filename=')) {
        name = disposition
            .split('filename=')[1]
            .replace(/["']/g, '')
            .trim();
    }
    filename && (name = filename);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    void afterTheSuccessFn?.();
}

// 下载文件
export const downloadFile = (url, fileName) => {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};
